<div class="taly-integration">
  <div class="platform-info">
    <h4 translate>LEARN_MORE_PAGE.EFFORTLESS</h4>
    <p translate>LEARN_MORE_PAGE.DEVOTE_TEAM</p>
  </div>

  <div class="platform-bg">
    <img src="assets/images/effortles-platform.svg" alt="Platform=img" />
  </div>
</div>
